const routes = {
	LOGIN: '/login',
	SIGNUP: '/signup',
	SIGNUPUSER: '/user-signup',
	FORGOTPASSWORD: '/forgot-password',
	RESETPASSWORD: '/reset-password',
	VERIFY: '/verify',
	INVOICES: '/invoices',
	INVOICEDETAIL: '/invoices/:invoiceId',
	ESTIMATES: '/estimates',
	ESTIMATESDETAIL: '/estimates/:id',
	WORKORDERS: '/work-orders',
	WORKORDERDETAIL: '/work-orders/:workOrderId',
	ACCOUNTSETTING: '/account-setting',
	MANAGEUSERS: '/manage-ursers',
	WORKFLOW: '/workflow',
	ADAS_REPORTS: '/adas-reports',
	ADAS_REPORT_DETAIL: '/adas-reports/:id',
}

export default routes
